import { DEFAULT_BUTTON_PROPERTIES } from '../constants/quickFilterButtonProperties';
import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FiltersBarContext = /*#__PURE__*/createContext(null);
export const FiltersBarProvider = ({
  advancedFiltersButtonState,
  associatedRecord,
  children,
  customPropertyNames,
  defaultPropertyNames,
  enableAdvancedFiltersButton,
  enableAutoOpenInputPopovers,
  enableClearAdvancedFiltersButton,
  enableCustomFilters,
  enableReordering,
  forceShowClearQuickFilters,
  maxCustomQuickFilters,
  onClearAdvancedFilters,
  onClearQuickFilters,
  onCustomPropertyNamesChange,
  onOpenAdvancedFilters,
  size
}) => {
  const [newestCustomPropertyName, setNewestCustomPropertyName] = useState(null);
  const prevCustomPropertyNames = useRef(customPropertyNames);
  useEffect(() => {
    if (customPropertyNames.length > prevCustomPropertyNames.current.length) {
      setNewestCustomPropertyName(customPropertyNames[customPropertyNames.length - 1]);
      // reset newestCustomPropertyName since prevCustomPropertyNames gets updated
      setTimeout(() => {
        setNewestCustomPropertyName(null);
      }, 0);
    }
    prevCustomPropertyNames.current = customPropertyNames;
  }, [customPropertyNames]);
  const defaultButtonProperties = useMemo(() => DEFAULT_BUTTON_PROPERTIES[size], [size]);
  const contextValue = useMemo(() => {
    return {
      advancedFiltersButtonState,
      associatedRecord,
      customPropertyNames,
      defaultButtonProperties,
      defaultPropertyNames,
      enableAdvancedFiltersButton,
      enableAutoOpenInputPopovers,
      enableClearAdvancedFiltersButton,
      enableCustomFilters,
      enableReordering,
      forceShowClearQuickFilters,
      maxCustomQuickFilters,
      newestCustomPropertyName,
      onClearAdvancedFilters,
      onClearQuickFilters,
      onCustomPropertyNamesChange,
      onOpenAdvancedFilters
    };
  }, [advancedFiltersButtonState, associatedRecord, customPropertyNames, defaultButtonProperties, defaultPropertyNames, enableAdvancedFiltersButton, enableAutoOpenInputPopovers, enableClearAdvancedFiltersButton, enableCustomFilters, enableReordering, forceShowClearQuickFilters, maxCustomQuickFilters, newestCustomPropertyName, onClearAdvancedFilters, onClearQuickFilters, onCustomPropertyNamesChange, onOpenAdvancedFilters]);
  return /*#__PURE__*/_jsx(FiltersBarContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useFiltersBarContext = () => {
  const context = useContext(FiltersBarContext);
  if (context === null) {
    throw new Error('useFiltersBarContext must be used within a FiltersBarProvider');
  }
  return context;
};
export default FiltersBarContext;